export const ABOUTUS_LOADING = "ABOUTUS_LOADING";
export const GET_ABOUTUS = "GET_ABOUTUS";
export const REMOVE_ABOUTUS = "REMOVE_ABOUTUS";
